<div class="wrapper">
  <!-- <sam-header class="header" [ngClass]="{'sticky': !(isListingPage$ | async)}"></sam-header> -->
  <div class="router" [@routeAnimations]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
</div>
